import { defineStore } from 'pinia';

interface ISoundState {
  sound: Map<string, HTMLAudioElement>;
}

export const useSoundStore = defineStore('sound', {
  state: (): ISoundState => ({
    sound: new Map(),
  }),

  getters: {
    isSounds: (state) => !!state.sound.size,
  },

  actions: {
    addSound(name: string) {
      const audio: HTMLAudioElement = new Audio('/sound/' + name + '.mp3');
      audio.volume = 0.01;
      this.sound.set(name, audio);
    },

    setSounds(names: string[] = []): Promise<void> {
      names.forEach((name) => {
        if (!this.sound.has(name)) {
          this.addSound(name);
        }
      });
      return Promise.resolve();
    },

    play(name: string) {
      const s = this.sound.get(name);
      if (s) {
        s.currentTime = 0;
        s.play();
      }
    },
  },
});

export default useSoundStore;
